import { h } from "preact";
import { StoryDTO } from "../model/Item";
import { StoryAuthorLink } from "./storyAuthorLink";
import { StoryBaseUrl } from "./storyBaseUrl";
import { StoryTitle } from "./storyTitle";
import { ItemLink } from "./itemLink";
import { dateFromUnixSeconds } from "../dateFromUnixSeconds";

interface StoryProps {
    story: StoryDTO;
}

export const Story = ({ story }: StoryProps) =>
    // TODO: Slice story.url into baseUrl for parenthesis
    <div className="story">
        <div className="title-row">
            <StoryTitle story={story} />
            <StoryBaseUrl story={story} />
        </div>
        <div className="info-row info-span">
            {story.score} points by
            <span> <StoryAuthorLink story={story} /></span>
            <span> <ItemLink item={story} text={dateFromUnixSeconds(story.time)} /></span>
            <span> | <ItemLink item={story} text={`${story.descendants} comments`} /></span>
        </div>
    </div>;
